import { BaseEntity } from "yt-ng-framework";

export class OpstinaView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv:string;
    Okrug:string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.Okrug=input.Okrug;
        return this;
    }

    Serialize(input:OpstinaView){
        return input;
    }
}